var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-video"},[(_vm.isSaveProgram)?_c('img',{staticClass:"field-media",attrs:{"src":_vm.media.ext_val_pimg,"alt":""}}):_c('video',{staticClass:"field-media",class:{'scale-type':!_vm.media.ext_val_scaleType},attrs:{"src":_vm.media.field_item_path,"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }